// src/pages/VerifyEmail.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendEmailVerification } from 'firebase/auth';
import { useAuth } from '../context/AuthContext';

export default function VerifyEmail() {
  const { currentUser, logout } = useAuth();
  const [resent, setResent] = useState(false);
  const [checking, setChecking] = useState(false);
  const navigate = useNavigate();

  const handleResend = async () => {
    await sendEmailVerification(currentUser, { url: `${window.location.origin}/verify-email-complete` });
    setResent(true);
    setTimeout(() => setResent(false), 5000);
  };

  const handleCheckVerification = async () => {
    setChecking(true);
    await currentUser.reload();
    if (currentUser.emailVerified) {
      navigate('/dashboard');
    } else {
      setChecking(false);
      alert('Email not yet verified. Please check your inbox and click the link.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 24 }}>
      <div style={{ maxWidth: 480, textAlign: 'center' }} className="fade-up">
        <div style={{ fontSize: '4rem', marginBottom: 24 }}>✉️</div>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', marginBottom: 12 }}>
          Check your inbox
        </h1>
        <p style={{ color: 'var(--ink-muted)', marginBottom: 32, lineHeight: 1.7 }}>
          We sent a verification link to <strong>{currentUser?.email}</strong>. Click it to activate your account — then come back here.
        </p>

        {resent && <div className="alert alert-success">Verification email resent!</div>}

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button className="btn btn-primary" onClick={handleCheckVerification} disabled={checking}>
            {checking ? <><span className="spinner" /> Checking...</> : "I've verified — continue →"}
          </button>
          <button className="btn btn-secondary" onClick={handleResend}>
            Resend email
          </button>
        </div>

        <p style={{ marginTop: 32, fontSize: '0.8rem', color: 'var(--ink-muted)' }}>
          Wrong email?{' '}
          <button
            onClick={async () => { await logout(); navigate('/login'); }}
            style={{ background: 'none', border: 'none', color: 'var(--accent)', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 500 }}
          >
            Sign out and try again
          </button>
        </p>
      </div>
    </div>
  );
}
